package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_11_08_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-11-08")
@Composable
public fun Log_2025_11_08(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Street-Feet Food",
        ogTitle = "Street-Feet Food",
        date = LocalDate(2_025, 11, 8),
        aiHint = "Title is a joke (cop humor)",
        ogDescription = "Yum yum get in my belly 🐓🐔🍜",
        ogImage = "images/chickenFeet_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration showing a cat-character (representing Bigglesworth) sitting at a table and eating a bowl of noodles. A chicken foot is sticking out of the bowl.",
    ) {
        SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
        Log_2025_11_08_Day_1()
        SessionMediaItem(
            image = "images/chickenFeet.webp",
            linkImage = "images/chickenFeet.webp",
            description = "A hand-drawn illustration showing a cat-character (representing Bigglesworth) sitting at a table and eating a bowl of noodles. A chicken foot is sticking out of the bowl.",
            width = 1_626,
            height = 2_691,
        )
    }
}
